import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
export const starInputRegex = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))$/gm;
export const underscoreInputRegex = /(?:^|\s)((?:__)((?:[^__]+))(?:__))$/gm;
export class BoldPlugin {
    constructor() {
        this.name = 'bold';
        this.spec = {
            type: 'mark',
            matchSelector: 'strong,b',
            matchStyle: {
                'font-weight': (weight) => /^(bold(er)?|[5-9]\d{2,})$/.test(weight) && {},
            },
            attrs: {
                filterUnBoldTag: {
                    parse: (node) => node.style.fontWeight !== 'normal',
                },
            },
            toDOM: 'strong',
        };
        this.toggle = () => this.editor.selection().toggleMark(this);
        this.isActive = () => this.editor.isActive(this);
        this.canApply = () => this.editor.selection().canToggleMark(this);
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                toggle: this.toggle,
                isActive: this.isActive,
            },
            shortcuts: {
                'Mod-b': this.toggle,
            },
            inputRules: [starInputRegex, underscoreInputRegex],
        };
    }
    renderToolbarItem() {
        const btn = document.createElement('exeditor-toolbar-button');
        Object.assign(btn, {
            label: this.editor.t('加粗'),
            shortcut: 'Mod-b',
            onclick: () => {
                this.editor.focus();
                this.toggle();
            },
        }).appendChild(createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.boldIcon),
        }));
        const setBtnProps = () => {
            btn.active = this.isActive();
            btn.disabled = !this.canApply();
        };
        setBtnProps();
        this.editor.on('idlechange', setBtnProps);
        return btn;
    }
}
//# sourceMappingURL=index.js.map